export interface UserAccount {
  userId: string;
  userPswd: string;
}

export interface TokenAccount {
  cstmrSno: number;
  refreshToken: string | null;
}
export interface MyPageFormData {
  data: UserPageData | undefined;
}
export interface ResponseUser {
  resultData: {
    accessToken: string;
    refreshToken: string;
    expires_in: number;
    scope: string | string[];
    jti: string;
    usrId: string;
    usrNo: number;
    role: string;
    encodedInfo: string | null;
  };
}

export interface LoginData {
  accessToken: string;
  refreshToken: string;
  expires_in: number;
  exp: string;
  scope: string | string[];
  jti: string;
  userId: string;
  cstmrSno: number;
  auth: string;
  encodedInfo: string | null;
}

export interface UserData {
  steCd: string;
  regDt: string;
  mdfcnDt: string;
  usrNo: number;
  usrJoinCours: string;
  usrId: string;
  usrNcnm: string;
  usrEmlAdres: string;
  usrPnt: string;
  usrNatCd: string;
  usrCpnb: string;
  usrAgeCd: string;
  usrSexdstn: string;
  usrItrtJs: string[];
  usrItrtJsStr: string;
  usrArmYn: string;
  usrSmsYn: string;
  authLevel: string;
  authNm: string;
}

export interface UserPageState {
  userPage?: UserPageData | undefined;
  result: boolean | undefined;
}
export interface UserPageData {
  memberName: string;
  cstmrSno: string;
  birthdyDate: string;
  genderCd: string;
  cntryCd: string;
  email: string;
  hpno: string;
  userId: string;
}
export interface UpdateData {
  email: string;
  updateUserId: string;
  cstmrSno: string;
  updateDt: string;
}

export interface UserPw {
  newPswd: string;
  newPswdConfirm: string;
}
export interface UserPwCheck {
  result: string;
}

export interface UserPwState {
  userPwPage: UserPw | undefined;
}
export const initResponseUserPwPageData = {
  userPwPage: undefined
};

export const initResponseUserPageData = {
  userPage: undefined,
  result: undefined
};
